import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class TagIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M15.536 8.207L7.793.464A1.406 1.406 0 0 0 6.71 0H1.548A1.52 1.52 0 0 0 0 1.548V6.71a1.406 1.406 0 0 0 .465 1.083l7.742 7.742a1.497 1.497 0 0 0 2.167 0l5.161-5.16a1.497 1.497 0 0 0 0-2.168zM4.8 6.4a1.6 1.6 0 1 1 1.6-1.6 1.604 1.604 0 0 1-1.6 1.6z"/></svg>
        )
    }
}

export default withCssClassName(TagIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/tag-icon.js